import React from 'react';
import { Col, Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { FormItem } from '../../../components/FormItem';
import { usePersonalisedReportContext } from '../../../../context';

export const Organizations: React.FC = () => {
	const { personalisedReport, organization_id } = usePersonalisedReportContext();

	const organizations = [
		{
			label: personalisedReport?.basic_information?.organization_name,
			value: organization_id
		}
	];

	return (
		<Col xs={24}>
			<FormItem
				fontSize="1rem"
				isRequired={true}
				title={I18n.get('Company')}
				namePath={['basic_information', 'organization_id']}
			>
				<Select size="large" disabled={true} value={organization_id} options={organizations} />
			</FormItem>
		</Col>
	);
};
